/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Days_Fixed_FixedInputs */

const en_us2_onboarding_days_fixed_fixed = /** @type {(inputs: Onboarding_Days_Fixed_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Same days every week`)
};

const pt_br2_onboarding_days_fixed_fixed = /** @type {(inputs: Onboarding_Days_Fixed_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sempre nos mesmos dias`)
};

const es_419_onboarding_days_fixed_fixed = /** @type {(inputs: Onboarding_Days_Fixed_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siempre los mismos días`)
};

const pt_pt2_onboarding_days_fixed_fixed = /** @type {(inputs: Onboarding_Days_Fixed_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sempre nos mesmos dias`)
};

const fr_fr2_onboarding_days_fixed_fixed = /** @type {(inputs: Onboarding_Days_Fixed_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les mêmes jours chaque semaine`)
};

const de_de2_onboarding_days_fixed_fixed = /** @type {(inputs: Onboarding_Days_Fixed_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Woche dieselben Tage`)
};

const it_it2_onboarding_days_fixed_fixed = /** @type {(inputs: Onboarding_Days_Fixed_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sempre gli stessi giorni`)
};

/**
* | output |
* | --- |
* | "Same days every week" |
*
* @param {Onboarding_Days_Fixed_FixedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_days_fixed_fixed = /** @type {((inputs?: Onboarding_Days_Fixed_FixedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Days_Fixed_FixedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_days_fixed_fixed(inputs)
	if (locale === "es-419") return es_419_onboarding_days_fixed_fixed(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_days_fixed_fixed(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_days_fixed_fixed(inputs)
	if (locale === "de-DE") return de_de2_onboarding_days_fixed_fixed(inputs)
	if (locale === "it-IT") return it_it2_onboarding_days_fixed_fixed(inputs)
	return en_us2_onboarding_days_fixed_fixed(inputs)
});
export { onboarding_days_fixed_fixed as "onboarding.days_fixed.fixed" }